import { BASE_URL, getAxiosConfig } from "../components/interface/Config";
import { apiHandler } from "./authService";

export const changePassword = async (
  currentPassword: string,
  newPassword: string,
  confirmPassword: string
): Promise<any> => {
  const authToken = sessionStorage.getItem("authToken");
  if (!authToken) {
    throw new Error("User is not authenticated. Please log in.");
  }
  
  const payload = {
    currentpassword: currentPassword,
    newpassword: newPassword,
    password: confirmPassword,
  }
  const url = `${BASE_URL}/users/change-password`;
  const response   = await apiHandler('', 'PATCH', payload, url);
  
  if (!response) {
      throw new Error("No response received from the server");
  }
  const data = response.data;

  // const response = await fetch(`${BASE_URL}/users/change-password`, {
  //   method: "PATCH",
  //   headers: getAxiosConfig().headers,
  //   body: JSON.stringify({
  //     currentpassword: currentPassword,
  //     newpassword: newPassword,
  //     password: confirmPassword,
  //   }),
  // });

  // if (!response.ok) {
  //   const data = await response.json();
  //   throw new Error(data.message || "Failed to change password.");
  // }

  // return await response.json();
  return data;
};
